import React from 'react'
import CustomDrawer from '../../Component/Common/CustomDrawer';
import { Title, useCommonStyles } from '../../utils';
import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid } from '@mui/material';

const CommonInventoryFilterDrawer = ({ isOpenFilterDrawer, setIsOpenFilterDrawer, setFilterData, initialFilterState, filterData, setIsApplyFilter, isApllyFilter }) => {

    // =============== Hooks ===============
    const { classes } = useCommonStyles();

    const handleTypeChange = (id) => {
        setFilterData((prev) => ({
            ...prev,
            status: prev.status === id ? "" : id
        }));
    };

    return (
        <CustomDrawer
            isOnlyIconClose
            isDrawerOpen={isOpenFilterDrawer}
            handleClose={() => { setIsOpenFilterDrawer(false) }}
            title="Filter"
        >
            <Grid container p={2}>
                <Grid item xs={12}>
                    <Title>Status</Title>
                </Grid>
                {[{ name: "In Use", id: 1 }, { name: "Not In Use", id: 2 }].map((ele) => (
                    <Grid item xs={12} sm={6} md={4} key={ele.id}>
                        <FormControl component="fieldset">
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={filterData.status === ele.id.toString()}
                                            onChange={() => handleTypeChange(ele.id.toString())}
                                        />
                                    }
                                    sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                    label={ele.name}
                                    labelPlacement="end"
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                ))}
                <Grid item xs={12} mt={2} display="flex" justifyContent="end" gap={2}>
                    <Button className={classes.cancelButton}
                        onClick={() => {
                            setFilterData(initialFilterState);
                            // setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1)
                        }
                        }>
                        Reset Filter
                    </Button>
                    <Button className={classes.saveButton} onClick={() => { setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) }}>
                        Apply Filter
                    </Button>
                </Grid>
            </Grid>
        </CustomDrawer>
    )
}

export default CommonInventoryFilterDrawer